(function (global) {
  'use strict';

  const clampPercent = value => Math.min(100, Math.max(0, Number(value) || 0));
  const discountedUnitPrice = (price, percent) => {
    const cents = Math.max(0, Number(price) || 0);
    return cents - Math.floor(cents * clampPercent(percent) / 100);
  };
  const bestBaseDiscount = (quantityPercent, campaignPercent) => Math.max(
    clampPercent(quantityPercent),
    clampPercent(campaignPercent)
  );
  const selectedBaseDiscount = (quantityPercent, campaignPercent) => (
    clampPercent(campaignPercent) > clampPercent(quantityPercent) ? 'campaign' : 'quantity'
  );
  const priceLines = (lines, basePercent, subscriptionPercent) => (Array.isArray(lines) ? lines : []).reduce(
    (total, line) => {
      const quantity = Math.max(0, Math.floor(Number(line.quantity) || 0));
      const hasSellingPlanPrice = line.subscriptionPrice !== undefined && line.subscriptionPrice !== null;
      const afterSubscription = hasSellingPlanPrice
        ? Math.max(0, Number(line.subscriptionPrice) || 0)
        : discountedUnitPrice(line.price, subscriptionPercent);
      return total + discountedUnitPrice(afterSubscription, basePercent) * quantity;
    },
    0
  );

  function subscriptionOffer(lines, {
    quantityPercent = 0,
    campaignPercent = 0,
    subscriptionPercent = 10
  } = {}) {
    const selectedPercent = bestBaseDiscount(quantityPercent, campaignPercent);
    return Object.freeze({
      initialBaseDiscount: selectedBaseDiscount(quantityPercent, campaignPercent),
      initialBasePercent: selectedPercent,
      initialTotal: priceLines(lines, selectedPercent, subscriptionPercent),
      renewalBaseDiscount: 'quantity',
      renewalBasePercent: clampPercent(quantityPercent),
      renewalTotal: priceLines(lines, quantityPercent, subscriptionPercent),
      subscriptionPercent: clampPercent(subscriptionPercent)
    });
  }

  const api = Object.freeze({
    bestBaseDiscount,
    selectedBaseDiscount,
    discountedUnitPrice,
    priceLines,
    subscriptionOffer
  });
  global.JoburgOfferPolicy = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
